import React from 'react';
import { motion } from 'framer-motion';

function IntroSection() {
  return (
    <section className="intro-section section-wrap" id="intro">
      <motion.p
        className="intro-lead"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
      >
        We design homes that feel collected, not decorated — spaces where
        <em> material, memory, and light </em>
        come together to tell a story that is quietly, unmistakably yours.
      </motion.p>
      <div className="intro-meta">
        <span>Est. 2014</span>
        <span className="intro-dot" />
        <span>Brooklyn, NY</span>
        <span className="intro-dot" />
        <span>Residential & Commercial</span>
      </div>
    </section>
  );
}

export default IntroSection;
